export enum ELanguage {
  Portuguese = 'pt-BR',
  English = 'en-US',
  Spanish = 'es-ES'
}
